export default __webpack_public_path__ + "static/security-min-b6c6957a062906032645eb9141206784.png";